<template>
  <div>
    <div class="card-body">
      <fieldset
        :disabled="readonly"
        style="border:0;padding:0;margin:0;min-width:0;"
      >
        <div class="text-right" v-if="!readonly">
          <form-button :indicator="form.processing()" @clicked="save">
            Save
          </form-button>
        </div>
        <div class="clearfix"></div>
        <hr />

        <toggleswitch
          :labels="true"
          name="received"
          label="Estimate Received?"
          v-model="form.received"
          :disabled="readonly"
          helper="Has the repair estimate been received?"
        ></toggleswitch>

        <!--      <div v-if="form.received">-->
        <!--        <div v-if="!estimate.document_id">-->
        <!--          <file-input-->
        <!--              name="document"-->
        <!--              label="Estimate"-->
        <!--              helper="Please choose a file"-->
        <!--              :show-error="form.errors.has('document')"-->
        <!--              v-on:selected="setDocument"-->
        <!--              :error-message="form.errors.get('document')"-->
        <!--          ></file-input>-->

        <!--          <div class="text-right">-->
        <!--            <button class="btn btn-primary btn-sm" v-on:click.prevent="save">-->
        <!--              Upload Estimate-->
        <!--            </button>-->
        <!--          </div>-->
        <!--        </div>-->

        <!--        <div v-else>-->
        <!--          <a class="btn btn-primary" v-on:click.prevent="viewDocument(estimate.document)" href="">View Estimate</a>-->
        <!--        </div>-->
        <!--      </div>-->

        <company-select
          heading="Engineer Details"
          label="Enter the details of the engineer"
          :types="companyTypes"
          :company="company"
          :readonly="readonly"
          ref="company"
        ></company-select>

        <!--    <div v-if="!form.received">-->
        <!--      <fieldset>-->
        <!--        <legend>Request Estimate</legend>-->

        <!--        <div v-if="!estimate.requested_at">-->
        <!--          <inputbox-->
        <!--            name="to"-->
        <!--            label="To"-->
        <!--            v-model="form.to"-->
        <!--            :show-error="form.errors.has('to')"-->
        <!--            :error-message="form.errors.get('to')"-->
        <!--            helper="Please enter the email addresses you would like to send the request to."-->
        <!--          ></inputbox>-->
        <!--          <inputbox-->
        <!--            name="cc"-->
        <!--            label="CC"-->
        <!--            v-model="form.cc"-->
        <!--            helper="Please enter the email addresses you would like to send a carbon copy."-->
        <!--          ></inputbox>-->
        <!--          <inputbox-->
        <!--            name="subject"-->
        <!--            label="Subject"-->
        <!--            v-model="form.subject"-->
        <!--            :show-error="form.errors.has('subject')"-->
        <!--            helper="Please enter the subject of the email address."-->
        <!--            :error-message="form.errors.get('subject')"-->
        <!--          ></inputbox>-->
        <!--          <input-block-->
        <!--            name="body"-->
        <!--            label="Message"-->
        <!--            v-model="form.body"-->
        <!--            :show-error="form.errors.has('body')"-->
        <!--            helper="Please enter content of the email."-->
        <!--            :error-message="form.errors.get('body')"-->
        <!--          ></input-block>-->

        <!--          <button class="btn btn-primary btn-sm" v-on:click.prevent="save">-->
        <!--            Send Email-->
        <!--          </button>-->
        <!--        </div>-->

        <!--        <div v-else>-->
        <!--          Estimate request sent by {{ estimate.requested_by.full_name }} at-->
        <!--          {{ requestedAt }}.-->
        <!--        </div>-->
        <!--      </fieldset>-->
        <!--    </div>-->
      </fieldset>
    </div>
    <div class="card-footer">
      <div class="text-right" v-if="!readonly">
        <form-button :indicator="form.processing()" @clicked="save">
          Save
        </form-button>
      </div>
    </div>
  </div>
</template>
<script>
import Company from './../../Shared/Company';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    'company-select': Company
  },

  data() {
    return {
      form: new window.Form({
        received: false,
        document: null,
        to: null,
        cc: null,
        subject: null,
        body: null,
        company_id: null,
        company_name: null,
        email_address: null,
        telephone: null,
        address_line_one: null,
        address_line_two: null,
        city: null,
        postcode: null
      }),
      companyTypes: ['engineer']
    };
  },

  computed: {
    estimate() {
      return this.$store.getters['Incident/estimate'];
    },

    company() {
      return {
        company_id: this.form.company_id,
        name: this.form.company_name,
        email_address: this.form.email_address,
        telephone_number: this.form.telephone,
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    },

    requestedAt() {
      if (this.estimate.requested_at) {
        return window.DateManager.format(this.estimate.requested_at);
      }

      return null;
    }
  },

  mounted() {
    window.Ajax.get('/incidents/' + this.incident + '/estimate')
      .then(response => {
        this.$store.commit('Incident/setEstimate', response.data);
        this.form.received = response.data.received || false;
        this.form.company_id = response.data.company_id;
        this.form.company_name = response.data.company_name;
        this.form.email_address = response.data.email_address;
        this.form.telephone = response.data.telephone;
        this.form.address_line_one = response.data.address_line_one;
        this.form.address_line_two = response.data.address_line_two;
        this.form.city = response.data.city;
        this.form.postcode = response.data.postcode;
      })
      .catch(error => {});
  },

  methods: {
    setDocument(data) {
      this.form.addFile(data.name, data.file);
    },

    save() {
      if (this.readonly) return;
      this.setCompany(this.$refs.company.form);

      this.form
        .post(`/incidents/${this.incident}/estimate`)
        .then(response => {
          window.toastify.success(
            'Success!',
            'The estimate was updated successfully!'
          );

          this.$store.commit('Incident/setEstimate', response);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'There was an issue, please try again'
          );
        });
    },

    setCompany(company) {
      this.form.company_id = company.company_id;
      this.form.company_name = company.name;
      this.form.email_address = company.email_address;
      this.form.telephone = company.telephone_number;
      this.form.address_line_one = company.address_line_one;
      this.form.address_line_two = company.address_line_two;
      this.form.city = company.city;
      this.form.postcode = company.postcode;
    },

    viewDocument(document) {
      let url = `${window.AxisUK.storage}${document.hash}`;

      window.open(url, '_blank');
    }
  }
};
</script>
